var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m288.1 0 86.5 164 182.7 31.6L428 328.5 454.4 512l-166.3-81.8L121.7 512l26.4-183.5L18.9 195.6 201.5 164z"
})));
export default SvgStar;